import shouldShowMenu from "./shouldShowMenu";
import useSelectedItems from './useSelectedItems';
import { useContext } from 'react';
import { FigureInteractionEventDispatch } from './Contexts';
import { SelectedItemInfo } from './SelectedItemProvider';
import getMenuItems from './getMenuItems';
import { SelectedItemsRefContext } from './SelectedItemProvider';

export default function useComputedMenuItems(source){

  const figureInteractionEventDispatch = useContext(FigureInteractionEventDispatch);
  let {nodeId,node,cellLocation} = source;

  let selHook = useSelectedItems();
  let selectedItemsStore = useContext(SelectedItemsRefContext);
  let selectedItems = selectedItemsStore?.getState();

  let { selectionTriggerItem } = selectedItems || {};
  const {possibleActions,unifiedGroup} = useContext(SelectedItemInfo);

/*  if( nodeId === "A" && cellLocation[0] === 2 && cellLocation[1] === 1){
  }
  */

  if( !selectionTriggerItem || !cellLocation ){
    return {};
  }

  let menuDecisionArgs = {
    triggerItem:selectionTriggerItem,
    thisNodeInfo:{ nodeId, node, cellLocation }
  }

  
  if( shouldShowMenu(menuDecisionArgs) ){


    let onEvent = event => {
        figureInteractionEventDispatch({
          ...event, 
          source
        });
      }
    let menuItems = getMenuItems({
      possibleActions,
      unifiedGroup,
      onEvent,
    })


    return { menuItems, onEvent };
  }
  return {};

}
